import styled from 'styled-components';
import {
  flexDirectionColumn,
  layerA,
} from '../styles/commonStyles';
import TransitStation from './transitStation';
import { hpStations } from './stationsData';

const HeatingPlatformMain = () => {
  return (
    <StationWrapper>
      {hpStations.map((station) => (
        <TransitStation key={station.id} data={station} />
      ))}
    </StationWrapper>
  );
};

export default HeatingPlatformMain;

const StationWrapper = styled.section`
  padding: 2px;
  border-radius: 36px 36px 33px 33px;

  ${layerA}
  ${flexDirectionColumn}
`;
